import React, { useState, useEffect } from 'react';
import { Zap, TrendingUp, Lock, AlertTriangle, CheckCircle, Bot } from 'lucide-react';

const AutomationHealthPanel = ({ axiosInstance }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHealth = async () => {
      try {
        const res = await axiosInstance.get('/automation-health');
        setData(res.data);
      } catch (err) {
        console.error('Failed to fetch automation health:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchHealth();
  }, [axiosInstance]);

  if (loading) {
    return (
      <div className="bg-[#1a1a2e] border border-gray-700 rounded-lg p-4 mb-6 animate-pulse">
        <div className="h-6 bg-gray-700 rounded w-48 mb-3"></div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-20 bg-gray-700/50 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  if (!data || data.total_entries === 0) return null;

  const metrics = [
    { label: 'Total Entries', value: data.total_entries, icon: TrendingUp, color: 'text-gray-300', borderColor: 'border-gray-500' },
    { label: 'Auto-Generated', value: data.auto_generated, pct: data.auto_generated_pct, icon: Bot, color: 'text-blue-400', borderColor: 'border-blue-500' },
    { label: 'TL Confirmed', value: data.tl_confirmed, pct: data.tl_confirmed_pct, icon: CheckCircle, color: 'text-green-400', borderColor: 'border-green-500' },
    { label: 'Auto-Locked', value: data.auto_locked, icon: Lock, color: 'text-red-400', borderColor: 'border-red-500' },
    { label: 'Anomalies', value: data.anomalies_flagged, icon: AlertTriangle, color: 'text-amber-400', borderColor: 'border-amber-500' },
    { label: 'Auto-Fulfilled', value: data.commitments_auto_fulfilled, icon: CheckCircle, color: 'text-emerald-400', borderColor: 'border-emerald-500' },
  ];

  return (
    <div className="bg-[#1a1a2e] border border-gray-700 rounded-lg p-4 mb-6">
      <h3 className="text-lg font-semibold text-white mb-3 flex items-center gap-2">
        <Zap size={18} className="text-amber-400" />
        Automation Health
        <span className="text-xs text-gray-400 font-normal ml-2">Today</span>
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {metrics.map((m) => {
          const Icon = m.icon;
          return (
            <div key={m.label} className={`bg-[#0f0f23] border-l-2 ${m.borderColor} rounded-lg p-3`}>
              <div className="flex items-center gap-1.5 mb-1">
                <Icon size={14} className={m.color} />
                <span className="text-xs text-gray-400">{m.label}</span>
              </div>
              <div className={`text-2xl font-bold ${m.color}`}>
                {m.value}
                {m.pct !== undefined && (
                  <span className="text-xs text-gray-500 ml-1">({m.pct}%)</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AutomationHealthPanel;
